module.exports = __webpack_public_path__ + "media/images/img/topiamge-7b4bdfe67fce909e8133e30cfe136b68.png";